import { useLoaderData } from '@remix-run/react'
import { RichText } from '~/components/RichText'
import QuoteBlock from '~/components/press/QuoteBlock'
import Cta from '~/components/press/CTA'
import InfoWidget from '~/components/press/InfoWidget'
import NextArticle from '~/components/press/NextArticle'
import { TypeBrandBlurb, TypePressReleaseArticles } from '~/types/contentful'
import { Document } from '@contentful/rich-text-types'

export default function ArticleContent() {
  const { articleData } = useLoaderData() as {
    articleData: TypePressReleaseArticles<'WITHOUT_UNRESOLVABLE_LINKS', string>
  }

  const { brandBlurb, body, nextArticleEntry } = articleData.fields

  return (
    <div className="flex flex-col max-md:gap-12 my-0 md:mx-20 lg:mx-40 gap-24 pt-12 px-0 pb-24 max-lg:my-0 max-lg:gap-18 max-md:py-0 max-md:pr-2 max-md:pl-4 max-md:px-0 max-md:pt-8 max-md:pb-12">
      <div className="flex justify-between max-md:flex-col max-md:gap-12 max-lg:gap-18 max-xl:gap-22 gap-40">
        <div className="flex flex-col gap-6 max-lg:gap-5 max-md:gap-4">
          {body?.content?.map((entry, entryIdx: number) => {
            switch (entry.nodeType) {
              case 'embedded-entry-block':
                return entry?.data?.target?.fields?.quote ? (
                  <QuoteBlock key={entryIdx} entry={entry as unknown as Document} />
                ) : (
                  <InfoWidget key={entryIdx} entry={entry} />
                )
              default:
                return <RichText key={entryIdx} doc={entry as unknown as Document} />
            }
          })}
          {nextArticleEntry && (
            <NextArticle
              entry={
                nextArticleEntry as TypePressReleaseArticles<'WITHOUT_UNRESOLVABLE_LINKS', string>
              }
            />
          )}
        </div>
        {brandBlurb && (
          <Cta
            image={
              (brandBlurb as TypeBrandBlurb<'WITHOUT_UNRESOLVABLE_LINKS', string>)?.fields
                ?.brandLogo
            }
            blockTitle={
              (brandBlurb as TypeBrandBlurb<'WITHOUT_UNRESOLVABLE_LINKS', string>)?.fields
                ?.brandName as string
            }
            blockDescription={
              (brandBlurb as TypeBrandBlurb<'WITHOUT_UNRESOLVABLE_LINKS', string>)?.fields
                ?.brandDescription as string
            }
          />
        )}
      </div>
    </div>
  )
}
